/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant;
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant;
 *   var quantity = event.detail.quantity;
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event.
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * You can force refresh the mini-cart with:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* =========================================================
   EXISTING KLAVIYO / META LEAD TRACKING
   ========================================================= */

window.addEventListener('klaviyoForms', function (e) {
  if (e.detail.type === 'submit') {
    if (typeof fbq === 'function') {
      fbq('track', 'Lead');
    }
  }
});


/* =========================================================
   SEMILAC CART BEHAVIOUR TRACKING
   ========================================================= */

(function () {
  'use strict';

  const SESSION_STORAGE_KEY =
    'semilac_cart_tracking_session';

  const PENDING_FULL_CART_KEY =
    'semilac_pending_full_cart_view';

  let lastCartSnapshot = {
    cart_value: null,
    cart_item_count: null,
    cart_line_count: null,
    total_discount: null,
    free_items: null,
    discount_titles: '',
    item_types: '',
    item_handles: ''
  };

  let miniCartWasOpen = false;


  /* =========================================================
     SESSION ID
     ========================================================= */

  function createSessionId() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID === 'function'
    ) {
      return window.crypto.randomUUID();
    }

    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }


  /* =========================================================
     SESSION / SOURCE DATA
     ========================================================= */

  function getSessionData() {
    try {
      const existing =
        sessionStorage.getItem(
          SESSION_STORAGE_KEY
        );

      if (existing) {
        return JSON.parse(existing);
      }

      const params =
        new URLSearchParams(
          window.location.search
        );

      const data = {
        session_id:
          createSessionId(),

        landing_path:
          window.location.pathname +
          window.location.search,

        referrer:
          document.referrer || '',

        utm_source:
          params.get('utm_source') || '',

        utm_medium:
          params.get('utm_medium') || '',

        utm_campaign:
          params.get('utm_campaign') || ''
      };

      sessionStorage.setItem(
        SESSION_STORAGE_KEY,
        JSON.stringify(data)
      );

      return data;

    } catch (error) {
      return {
        session_id:
          createSessionId(),

        landing_path:
          window.location.pathname,

        referrer:
          document.referrer || '',

        utm_source: '',
        utm_medium: '',
        utm_campaign: ''
      };
    }
  }


  /* =========================================================
     CART URL
     ========================================================= */

  function getCartUrl() {
    const cartUrl =
      window.routes &&
      window.routes.cartUrl
        ? window.routes.cartUrl
        : '/cart';

    return (
      cartUrl.replace(/\/$/, '') +
      '.js'
    );
  }


  /* =========================================================
     CART SNAPSHOT
     ========================================================= */

  function refreshCartSnapshot() {
    return fetch(
      getCartUrl(),
      {
        credentials:
          'same-origin',

        headers: {
          Accept:
            'application/json'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Unable to fetch cart'
          );
        }

        return response.json();
      })
      .then(function (cart) {
        const items =
          Array.isArray(cart.items)
            ? cart.items
            : [];

        let freeItems = 0;

        items.forEach(
          function (item) {
            if (
              Number(
                item.final_price
              ) === 0
            ) {
              freeItems +=
                Number(
                  item.quantity || 0
                );
            }
          }
        );

        const discountTitles =
          (
            cart.cart_level_discount_applications ||
            []
          )
            .map(
              function (discount) {
                return (
                  discount.title ||
                  ''
                );
              }
            )
            .filter(Boolean)
            .join('|');

        const itemTypes =
          [
            ...new Set(
              items
                .map(
                  function (item) {
                    return (
                      item.product_type ||
                      ''
                    );
                  }
                )
                .filter(Boolean)
            )
          ].join('|');

        const itemHandles =
          items
            .map(
              function (item) {
                return (
                  item.handle ||
                  ''
                );
              }
            )
            .filter(Boolean)
            .join('|');

        lastCartSnapshot = {
          cart_value:
            Number(
              cart.total_price || 0
            ) / 100,

          cart_item_count:
            Number(
              cart.item_count || 0
            ),

          cart_line_count:
            items.length,

          total_discount:
            Number(
              cart.total_discount || 0
            ) / 100,

          free_items:
            freeItems,

          discount_titles:
            discountTitles,

          item_types:
            itemTypes,

          item_handles:
            itemHandles
        };

        return lastCartSnapshot;
      })
      .catch(function (error) {
        console.warn(
          '[SEMILAC TRACKING] Cart snapshot failed',
          error
        );

        return lastCartSnapshot;
      });
  }


  /* =========================================================
     ANALYTICS AVAILABILITY
     ========================================================= */

  function analyticsIsReady() {
    return (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish ===
        'function'
    );
  }


  /* =========================================================
     PUBLISH EVENT
     ========================================================= */

  function publishSemilacEvent(
    eventName,
    extraData
  ) {
    if (!analyticsIsReady()) {
      return Promise.resolve(
        false
      );
    }

    const sessionData =
      getSessionData();

    const data =
      Object.assign(
        {},
        sessionData,
        lastCartSnapshot,
        extraData || {},
        {
          page_path:
            window.location.pathname +
            window.location.search,

          is_mobile:
            window.matchMedia(
              '(max-width: 640px)'
            ).matches
        }
      );

    return Shopify.analytics
      .publish(
        eventName,
        data
      )
      .then(function () {
        return true;
      })
      .catch(function (error) {
        console.warn(
          '[SEMILAC TRACKING]',
          eventName,
          error
        );

        return false;
      });
  }


  /* =========================================================
     WAIT FOR SHOPIFY ANALYTICS
     ========================================================= */

  function publishWhenReady(
    eventName,
    extraData,
    attemptsLeft
  ) {
    if (analyticsIsReady()) {
      return publishSemilacEvent(
        eventName,
        extraData
      );
    }

    if (attemptsLeft <= 0) {
      console.warn(
        '[SEMILAC TRACKING] Shopify analytics not ready'
      );

      return Promise.resolve(
        false
      );
    }

    return new Promise(
      function (resolve) {
        window.setTimeout(
          function () {
            resolve(
              publishWhenReady(
                eventName,
                extraData,
                attemptsLeft - 1
              )
            );
          },
          100
        );
      }
    );
  }


  /* =========================================================
     CART DRAWER OPENED
     ========================================================= */

  function checkMiniCartState() {
    const miniCart =
      document.getElementById(
        'mini-cart'
      );

    if (!miniCart) {
      miniCartWasOpen =
        false;

      return;
    }

    const isOpen =
      miniCart.getAttribute(
        'aria-hidden'
      ) === 'false';

    if (
      isOpen &&
      !miniCartWasOpen
    ) {
      miniCartWasOpen =
        true;

      refreshCartSnapshot()
        .then(function () {
          return publishWhenReady(
            'semilac:cart_drawer_opened',
            {
              checkout_source:
                'cart_drawer'
            },
            30
          );
        });
    }

    if (!isOpen) {
      miniCartWasOpen =
        false;
    }
  }


  const miniCartObserver =
    new MutationObserver(
      function () {
        checkMiniCartState();
      }
    );

  miniCartObserver.observe(
    document.documentElement,
    {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'aria-hidden'
      ]
    }
  );


  /* =========================================================
     CART ACTION CLICKS
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      /* -----------------------------------------------------
         VIEW FULL CART

         Store a temporary marker.
         The event is sent after /cart opens.
         ----------------------------------------------------- */

      const viewFullCart =
        event.target.closest(
          '#mini-cart .semilac-mini-cart-actions__view-cart'
        );

      if (viewFullCart) {
        try {
          sessionStorage.setItem(
            PENDING_FULL_CART_KEY,
            '1'
          );
        } catch (error) {
          console.warn(
            '[SEMILAC TRACKING] Unable to store full cart marker',
            error
          );
        }

        return;
      }


      /* -----------------------------------------------------
         CHECKOUT
         ----------------------------------------------------- */

      const checkoutButton =
        event.target.closest(
          'button[name="checkout"], input[name="checkout"]'
        );

      if (!checkoutButton) {
        return;
      }

      let checkoutSource =
        'unknown';

      if (
        checkoutButton.closest(
          '#mini-cart'
        )
      ) {
        checkoutSource =
          'cart_drawer';

      } else if (
        checkoutButton.closest(
          '.sml-mobile-cart-checkout'
        )
      ) {
        checkoutSource =
          'full_cart_mobile_sticky';

      } else if (
        checkoutButton.closest(
          'section[data-section-type="cart"]'
        )
      ) {
        checkoutSource =
          'full_cart';
      }

      publishWhenReady(
        'semilac:checkout_clicked',
        {
          checkout_source:
            checkoutSource
        },
        30
      );
    },
    true
  );


  /* =========================================================
     KEEP CART SNAPSHOT CURRENT
     ========================================================= */

  document.addEventListener(
    'product:added',
    function () {
      window.setTimeout(
        refreshCartSnapshot,
        150
      );
    }
  );


  document.documentElement
    .addEventListener(
      'cart:refresh',
      function () {
        window.setTimeout(
          refreshCartSnapshot,
          150
        );
      }
    );


  /* =========================================================
     TRACK DRAWER → FULL CART
     ========================================================= */

  function trackPendingFullCartView() {
    const isCartPage =
      window.location.pathname ===
        '/cart' ||
      window.location.pathname ===
        '/cart/';

    if (!isCartPage) {
      return;
    }

    let pending = false;

    try {
      pending =
        sessionStorage.getItem(
          PENDING_FULL_CART_KEY
        ) === '1';
    } catch (error) {
      pending = false;
    }

    if (!pending) {
      return;
    }

    refreshCartSnapshot()
      .then(function () {
        return publishWhenReady(
          'semilac:full_cart_viewed',
          {
            checkout_source:
              'cart_drawer_to_full_cart'
          },
          30
        );
      })
      .then(function (published) {
        if (!published) {
          return;
        }

        try {
          sessionStorage.removeItem(
            PENDING_FULL_CART_KEY
          );
        } catch (error) {
          /* No action required */
        }
      });
  }


  /* =========================================================
     INITIALISE
     ========================================================= */

  function initialiseTracking() {
    getSessionData();

    refreshCartSnapshot();

    checkMiniCartState();

    trackPendingFullCartView();
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseTracking
    );
  } else {
    initialiseTracking();
  }

})();